import Page from "../../features/SobreNosotros.feature/Page";


export default function SobreNosotros(){
    return(
        <div><Page/></div>
    )
}